import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ShareMapContainer, type ShareMapContainerProps,
} from './shareMap.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ShareMap: ShareMapContainerProps;
  }
}

modalRenderer.register('ShareMap', ShareMapContainer);
